import Const from 'constants';
import React from 'react';

class TeamStackHelper {
    constructor(stacks) {
        this.stacks = {...stacks};
        this.resetPool();
    }

    resetPool() {
        this.pool = {...this.stacks};
        return this;
    }

    isEmpty() {
        return isEmpty(this.getAll());
    }

    getAll() {
        return this.pool;
    }

    getOne(defaultValue = null) {
        let one = defaultValue,
            pool = this.getAll();
        if (!isEmpty(pool)) {
            for (let key in pool) {
                one = {...pool[key]};
                break;
            }
        }
        return one;
    }

    get length() {
        let q = 0;
        let pool = this.getAll();
        if (isEmpty(pool)) {
            return q;
        }
        Object.keys(pool).map(() => q++);
        return q;
    }

    hasExactly() {
        let pool = this.resetPool().filterByCondition(Const.STACKS_TYPE_EXACTLY).getAll();
        return !isEmpty(pool);
    }

    filterBy(condition = null, quantity = null) {
        this.resetPool();
        if (condition) {
            this.filterByCondition(condition);
        }
        if (quantity) {
            this.filterByQuantity(quantity);
        }
        return this;
    }

    filterByCondition(condition) {
        let arr = [];
        if (!isEmpty(this.pool)) {
            Object.keys(this.pool).map((key) => {
                if (this.pool[key].type == condition) {
                    arr.push({...this.pool[key]});
                }
            });
        }
        this.pool = arr;
        return this;
    }

    filterByQuantity(value) {
        let arr = [];
        if (!isEmpty(this.pool)) {
            Object.keys(this.pool).map((key) => {
                if (this.pool[key].numberPlayers == value) {
                    arr.push({...this.pool[key]});
                }
            });
        }
        this.pool = arr;
        return this;
    }

    static isTypeAtLeast(type) {
        return type === Const.STACKS_TYPE_AT_LEAST;
    }

    static isTypeAtMost(type) {
        return type === Const.STACKS_TYPE_AT_MOST;
    }

    static isTypeExactly(type) {
        return type === Const.STACKS_TYPE_EXACTLY;
    }
}

export default TeamStackHelper;

export function renderSelectPlayerCountsOptions(maxSingleTeamPlayers) {
    return Array.apply(null, {length: maxSingleTeamPlayers + 1}).map((elem, i) => {
        return (
            <option key={i} value={i}>
                {`${i} ${1 === i ? 'Player' : 'Players'}`}
            </option>
        );
    });
}
